import { REPLY_TARGET_DELETED_MESSAGE, REPLY_TARGET_RESOLVED_MESSAGE } from "../../../utils/comment-reply";
import type { LivePageSnapshot } from "../proposal-tracker/page-revisions";
import { COMMENT_PARAGRAPH_GONE_MESSAGE, commentParagraphIsPlacedBeside, commentParagraphReadsGone } from "./comment-target-recovery";

export interface CardTargetHeldBack {
  heldBackReason: string;
  targetGone: boolean;
}

export function replyTargetStateOf(targetCommentId: string, watchedPage: LivePageSnapshot): CardTargetHeldBack | null {
  if (!watchedPage.completed) return null;
  const targetComment = watchedPage.commentById.get(targetCommentId);
  if (targetComment === undefined) return { heldBackReason: REPLY_TARGET_DELETED_MESSAGE, targetGone: true };
  return targetComment.resolved ? { heldBackReason: REPLY_TARGET_RESOLVED_MESSAGE, targetGone: false } : null;
}

export function commentTargetStateOf(commentBookmarks: readonly string[], watchedPage: LivePageSnapshot, recoveryFoundNothing: boolean): CardTargetHeldBack | null {
  const recoveryFoundNoParagraph = recoveryFoundNothing && commentParagraphReadsGone(commentBookmarks, watchedPage);
  if (!recoveryFoundNoParagraph && !commentParagraphIsPlacedBeside(commentBookmarks)) return null;
  return { heldBackReason: COMMENT_PARAGRAPH_GONE_MESSAGE, targetGone: true };
}
